import store from '../store/store';
import { action } from 'satcheljs/lib/legacy';
export default action('setClauseType')(function setClauseType(clauseType, clauseId) {
    store.inboxRulesEditState.clauseMap.get(clauseId).clauseType = clauseType;
});
//# sourceMappingURL=setClauseType.js.map